import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Global } from './Global';
import { MicrosoftAuthService } from './authentication.service';


@Injectable({
    providedIn: 'root'
})
export class EntityService {
    
    private _http = inject(HttpClient)
    private _url = Global.url_user
    private _token = inject(MicrosoftAuthService).token()
    private _headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', 'Bearer ' + this._token);

    setEntity(entity: any){
        return this._http.patch(this._url + 'set-entity', entity, { headers: this._headers })
    }
}

